import _regenerator from "/var/jenkins_home/workspace/crm-admin-uat/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/crm-admin-uat/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import MinCom from './minCom.vue';
import { consultHistory, followLog, infoUpdateLog, getRegistedList, movingLog } from '@/api/admissionCounseling/customerDrawerCom';
export default {
  name: 'LogCom',
  components: {
    MinCom: MinCom
  },
  props: {
    cId: {
      type: Number,
      required: true
    },
    aiErrorReasonOpt: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      tabs: [{
        id: '0',
        label: '咨询历史',
        api: consultHistory
      }, {
        id: '1',
        label: '跟进记录',
        api: followLog
      }, {
        id: '2',
        label: '信息变更',
        api: infoUpdateLog
      }, {
        id: '3',
        label: '订单交易',
        api: getRegistedList
      }, {
        id: '4',
        label: '流转日志',
        api: movingLog
      }],
      activeName: '0',
      log: [],
      sort: 1 // 升降序，1为降序，2为升序
    };
  },
  watch: {
    cId: function cId(newVal) {
      if (newVal) {
        this.getLog();
      }
    }
  },
  mounted: function mounted() {
    this.getLog();
  },
  methods: {
    getLog: function getLog() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var tabs, activeName, cId, sort, api, res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              tabs = _this.tabs, activeName = _this.activeName, cId = _this.cId, sort = _this.sort;
              api = tabs.filter(function (tab) {
                return tab.id === activeName;
              })[0].api;
              _context.n = 1;
              return api(cId, sort);
            case 1:
              res = _context.v;
              if (['0', '1'].includes(activeName)) {
                _this.log = res.rows;
              } else {
                _this.log = res;
              }
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    handleTabChange: function handleTabChange(e) {
      this.getLog();
      if (e.name === '1') {
        this.$emit('getLabel');
      }
    },
    handleBeforeChange: function handleBeforeChange(newVal) {
      if (newVal === '5') {
        this.handleSort();
        return false;
      }
    },
    handleSort: function handleSort() {
      var sort = this.sort;
      if (sort === 1) {
        this.sort = 2;
      } else {
        this.sort = 1;
      }
    }
  }
};